import { localDataExam } from "util/setLocalStorageTesting";

const checkTypeRandom = (props, dataExam) =>
  props?.isRandom ||
  dataExam?.type === "RandomExam" ||
  dataExam.typeExam === "randomExam";
const checkTypeGroup = (props, dataExam) =>
  props?.groupId ||
  dataExam?.type === "GroupExam" ||
  dataExam.typeExam === "groupExam" ||
  dataExam?.groupId;
const checkTypeOldExam = (user, props, dataExam) =>
  !props?.isRandom &&
  localDataExam.get(props?.groupId)?.groupId === dataExam?.groupId && // id group ตรงกับที่บันทึกไว้หรือไม่
  localDataExam.get(props?.groupId)?.data?.id === dataExam?.examId && // id exam ตรงกับที่บันทึกไว้หรือไม่
  localDataExam.get(props?.groupId)?.userId === user.id && // id user ตรงกับที่บันทึกไว้หรือไม่
  localDataExam.get(props?.groupId)?.dataQuestion; // มีข้อมูลคำถามหรือไม่
export const checkPreviousDataExam = (props, dataExam) =>
  props?.location?.state?.previousData && !dataExam;
export const previousDataExam = (props, dataExam) => {
  dataExam = {};
  dataExam = props.location.state?.previousData;
  dataExam.previousData = true;
  return dataExam;
};

export const checkTypeExam = (user, props, dataExam) => {
  let messageType;
  if (checkPreviousDataExam(props, dataExam)) {
    dataExam = previousDataExam(props, dataExam);
  }
  if (checkTypeRandom(props, dataExam)) messageType = "RandomExam";
  else if (checkTypeOldExam(user, props, dataExam)) messageType = "OldExam";
  else if (checkTypeGroup(props, dataExam)) messageType = "GroupExam";
  else if (dataExam?.type) messageType = dataExam?.type;
  return messageType;
};
